<template>
  <div class="new_message_container">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>我要留言</span>
    </div>
    <div class="new_msg_box">
      <van-field class="msg_box" v-model="data.leaveWord" rows="6" autosize type="textarea" placeholder="请输入您的留言" />
      <van-radio-group v-model="data.isOpen" direction="horizontal" icon-size="16" checked-color="#e60012">
        <van-radio name="1">所有人可见</van-radio>
        <van-radio name="0">仅自己可见</van-radio>
      </van-radio-group>
      <div class="operate_box">
        <span class="operate_btn" @click="submitMessage">提交</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import mediaApi from "@/api/apis/media.js";
export default {
  name: "MediaDetail",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      data: {
        nodeCode: null,
        memberId: null,
        freChannelId: null,  // 是 String 自媒体id
        leaveWord: '', // 是 String 留言内容
        isOpen: '1',// 否 Integer 否公开 0：否，1：是
      },
    };
  },
  methods: {
    /* 提交留言 */
    submitMessage() {
      var _this = this;

      mediaApi.addSelfMediaMessages(_this.data)
        .then((res) => {
          if (res.suc == 1) {
            _this.$dialog
              .alert({
                message: "添加成功",
              })
              .then(() => {
                _this.$router.go(-1);
              });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    }
  },
  created() {
    // 中宣部埋点：首页页面浏览（自媒体留言页，无内容详情对象）
    this.$track.trackPageViewOnce(
      this.$track.EVENT_CODE.HOME_PG,
      this.$track.mapArticleProps({}, {
        pageName: "自媒体留言页",
        pageId: "new_message",
        extra: { article_type: "自媒体" },
      })
    );
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "freChannelId")) {
      this.data.freChannelId = Number(query.freChannelId);
    }
    this.data.nodeCode = this.nodeCode;
    this.data.memberId = this.userInfo.id;
  },
};
</script>
<style scoped lang="scss">
.new_message_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .new_msg_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    .msg_box {
      background-color: #f7f7f7;
      &.van-cell {
        padding: 10px;
      }
    }
    .van-radio-group.van-radio-group--horizontal {
      padding-top: 10px;
      font-size: 14px;
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 5px 5px;
    .operate_btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background-color: #e60012;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>